import { render, staticRenderFns } from "./TopupTransactionDetails.vue?vue&type=template&id=22eeda1e"
import script from "./TopupTransactionDetails.vue?vue&type=script&lang=js"
export * from "./TopupTransactionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports